import { FormValidator } from "../types";

const isString = (v: unknown): v is string => typeof v === "string";
const isNil = (v: unknown): boolean => v == null;

export const isMandatory: FormValidator = {
  error: "Field is mandatory",
  isValid: (value: any) => {
    return isString(value) ? value.length > 0 : !isNil(value);
  },
};
